import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';


interface selectList {
  value: string | number,
  optList: { label: string, value: string }[],
  modelChange?: ($event) => void
}

@Component({
  selector: 'bcac-select-group',
  templateUrl: './bcac-select-group.component.html',
  styleUrls: ['./bcac-select-group.component.scss']
})

export class BcacSelectGroupComponent implements OnInit {

  constructor() { }

  selectList: selectList[] = [];
  bodyElement: HTMLBodyElement;
  bodyClass;
  ngOnInit() {}

  @Input()
  set bcacSelectList(selectList: {
    value: string | number,
    optList: { label: string, value: string }[],
    modelChange?: ($event) => void
  }[]) {
    this.selectList = [];
    for (let i = 0; i < selectList.length; i++) {
      if (_.isNil(selectList[i].value)) {
        if (Array.isArray(selectList[i].optList) && selectList[i].optList.length > 0) {
          selectList[i]['value'] = selectList[i].optList[0].value;
        } 
      }
      selectList[i]['modelChange'] = ($event) => { this.selectedListChange() }
      this.selectList.push(selectList[i])
    }
    let selectedValueArr = [];
    for (const iterator of this.selectList) {
      selectedValueArr.push(iterator.value);
    }
    this.bcacSelectedChange.emit(selectedValueArr);
  }

  @Output() bcacSelectedChange: EventEmitter<string[]> = new EventEmitter()

  selectedListChange() {
    let selectedValueArr = [];
    for (const iterator of this.selectList) {
      selectedValueArr.push(iterator.value);
    }
    this.bcacSelectedChange.emit(selectedValueArr);
  }

}
